export default __webpack_public_path__ + "static/media/UpdatedPDFIcon.5f7ee208.svg";